import type { PermissionConfig } from '@openx/utils/permission/context/PermissionContext';
import { useAclInfo } from './utils/useAclInfo';
import { useExchangeSession } from './utils/useExchangeSession';
import { useIsAllowed } from './utils/useIsAllowed';
import { useMatchesOrganizationType } from './utils/useMatchesOrganizationType';

export const permissionConfig: PermissionConfig = {
  useAclInfo,
  useIsAllowed,
  useMatchesOrganizationType,
  useSession: useExchangeSession,
};
